//src/pages/projects/SelectNextStepsPage.js
import React from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";

const SelectNextStepsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId, materialsCount } = location.state || {};

  const backButtonHandler = () => {
    navigate("/projects");
  };

  const handleAIQuestions = () => {
    navigate(`/create-assessment/step1/${projectId}`);
  };

  const handleSelfCreate = () => {
    navigate(`/self-create-assessment/step1/${projectId}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#eef2ff] via-white to-[#fdf2f8] flex flex-col items-center px-4 py-8">

     
      <div className="w-full max-w-5xl mb-6">
        <button
          onClick={backButtonHandler}
          className="group flex items-center gap-3 px-5 py-2.5 rounded-full bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold shadow-md hover:scale-105 active:scale-95 transition"
        >
          <IoMdArrowRoundBack className="text-xl group-hover:-translate-x-1 transition" />
          <span className="hidden md:block">Back</span>
        </button>
      </div>

      
      <div className="w-full max-w-5xl bg-white rounded-3xl shadow-2xl p-6 md:p-10 border border-gray-100">

        
        <div className="text-center">
          <h1 className="text-2xl md:text-3xl font-bold bg-[#36369f] text-transparent bg-clip-text">
            Choose How You Want to Create Questions
          </h1>
          <p className="text-gray-500 mt-4 text-sm md:text-base max-w-2xl mx-auto">
            Create your own questions according to the difficulty level and the number of questions you want, 
            completely by yourself or else you can also generate questions using our AI from the Learning materials 
            you uploaded , taking them as reference.
          </p>
        </div>

      
        <div className="grid md:grid-cols-2 gap-6 mt-10">

          
          <button
            onClick={handleAIQuestions}
           className="group relative overflow-hidden rounded-2xl p-6  bg-gradient-to-l from-indigo-950 to-indigo-800 text-white shadow-xl hover:scale-105 transition-all duration-300"
          >
           
            {/* <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition"></div> */}
             <div className="absolute inset-0 pointer-events-none">
               <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%]  bg-gradient-to-r from-transparent via-white/30 to-transparent 
                           rotate-[25deg] opacity-0  group-hover:opacity-100 group-hover:translate-x-[50%] transition-all duration-700">
              </div>
            </div>
            <div className="flex flex-col items-start gap-4 relative z-10">
              <img src="/generative.png" alt="" className="w-16 h-16" />

              <h2 className="text-lg font-bold text-white">
                Use Suggested AI Questions 
              </h2>

              <p className="text-sm text-white/80">
              (based on the learning materials you uploaded.)
              </p>

              {/* <span className="text-sm font-semibold text-blue-700">
                 Fast • Smart • Automated
              </span> */}
            </div>
          </button>

         
          <button
            onClick={handleSelfCreate}
           className="group relative overflow-hidden rounded-2xl p-6 bg-gradient-to-l from-indigo-950 to-indigo-800
                      text-white shadow-xl hover:scale-105 transition-all duration-300"
          >
            {/* <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition"></div> */}
                <div className="absolute inset-0 pointer-events-none">
                     <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%] bg-gradient-to-r from-transparent via-white/30 to-transparent 
                          rotate-[25deg] opacity-0  group-hover:opacity-100 group-hover:translate-x-[50%] transition-all duration-700">
                     </div>
                </div>
            <div className="flex flex-col items-start gap-4 relative z-10">
              <img src="/idea.png" alt="" className="w-16 h-16" />

              <h2 className="text-lg font-bold text-white">
                Create your own assessment 
              </h2>
 
             <p className="text-sm text-white/80">
               (self create your own assessment from scratch.)
              </p>

              {/* <span className="text-sm font-semibold text-green-700">
                 Flexible • Custom • Manual
              </span> */}
            </div>
          </button>

        </div>

        
        {materialsCount === 0 && (
          <p className="mt-6 text-center text-sm text-red-500 font-medium">
          Materials are required to use AI-generated questions. Please upload materials first.
          </p>
        )}
         

      </div>
    </div>
  );
};

export default SelectNextStepsPage;